import moment from "moment";
import { API_DELETE, API_POST, API_PUT } from "../../../helpers/api";

const PARAMETERS = {
  edit: function ({ inputs, parameterId, parameterName }) {
    return API_PUT(`system-parameter/parameter`, {
      ...inputs,
      startDate: moment(inputs.startDate).format("YYYY-MM-DD"),
    });
  },
};

const PROCESS = {
  edit: function ({ inputs, processId }) {
    return API_PUT(`system-parameter/process/${processId}`, inputs);
  },
};
const OFF_DAY = {
  delete: function ({ offDayId }) {
    return API_DELETE(`system-parameter/off-day/${offDayId}`);
  },
  edit: function ({ inputs, offDayId }) {
    return API_PUT(`system-parameter/off-day/${offDayId}`, {
      ...inputs,
      startDate: moment(inputs.startDate).format("YYYY-MM-DD"),
      endDate: moment(inputs.endDate).format("YYYY-MM-DD"),
    });
  },
  add: function ({ inputs }) {
    return API_POST("system-parameter/off-day", {
      ...inputs,
      startDate: moment(inputs.startDate).format("YYYY-MM-DD"),
      endDate: moment(inputs.endDate).format("YYYY-MM-DD"),
    });
  },
};
const SESSION = {
  edit: function ({ inputs, sessionId }) {
    return API_PUT(`system-parameter/session/${sessionId}`, inputs);
  },
  add: function ({ inputs }) {
    return API_POST("system-parameter/session", inputs);
  },
};
const CONTRACT = {
  edit: function ({ inputs, contractId }) {
    return API_PUT(`system-parameter/contract/${contractId}`, inputs);
  },
  add: function ({ inputs }) {
    return API_POST("system-parameter/contract", inputs);
  },
};

const REQUEST = {
  PARAMETERS: PARAMETERS,
  PROCESS: PROCESS,
  OFF_DAY: OFF_DAY,
  SESSION: SESSION,
  CONTRACT: CONTRACT,
};

export { REQUEST };
